(() => {
  const root = document.querySelector('[data-gv-hero-slideshow]');
  if (!root) return;

  const slides = Array.from(root.querySelectorAll('[data-gv-hs-slide]'));
  if (slides.length < 2) return;

  const dots = Array.from(root.querySelectorAll('[data-gv-hs-dot]'));
  const prevBtn = root.querySelector('[data-gv-hs-prev]');
  const nextBtn = root.querySelector('[data-gv-hs-next]');
  const countEl = root.querySelector('[data-gv-hs-count]');
  const progress = root.querySelector('[data-gv-hs-progress]');
  const autoplay = root.dataset.autoplay === 'true';
  const speed = Math.max(4, Number(root.dataset.speed || 6)) * 1000;
  let index = 0;
  let timer = null;
  let paused = false;

  const pad = (n) => String(n).padStart(2, '0');

  const setProgress = (run) => {
    if (!progress) return;
    progress.classList.remove('is-running');
    progress.style.removeProperty('--gv-hs-speed');
    // restart animation
    void progress.offsetWidth;
    if (run && autoplay && !paused) {
      progress.style.setProperty('--gv-hs-speed', `${speed}ms`);
      progress.classList.add('is-running');
    }
  };

  const goTo = (next) => {
    const i = (next + slides.length) % slides.length;
    slides.forEach((slide, idx) => {
      const on = idx === i;
      slide.classList.toggle('is-active', on);
      if (on) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });
    dots.forEach((dot, idx) => {
      const on = idx === i;
      dot.classList.toggle('is-on', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (countEl) countEl.textContent = `${pad(i + 1)} / ${pad(slides.length)}`;
    index = i;
    setProgress(true);
  };

  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    if (!autoplay || paused) return;
    timer = setInterval(next, speed);
    setProgress(true);
  };

  prevBtn?.addEventListener('click', () => {
    prev();
    start();
  });
  nextBtn?.addEventListener('click', () => {
    next();
    start();
  });
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      goTo(Number(dot.dataset.gvHsDot));
      start();
    });
  });

  root.addEventListener('mouseenter', () => {
    paused = true;
    stop();
    setProgress(false);
  });
  root.addEventListener('mouseleave', () => {
    paused = false;
    start();
  });

  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      prev();
      start();
    }
    if (e.key === 'ArrowRight') {
      next();
      start();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
      setProgress(false);
    } else if (!paused) {
      start();
    }
  });

  goTo(0);
  start();
})();
